// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// Author Taehoon Moon 2014
import { Note } from './note';
import { TimeSignature } from './timesignature';
import { Category } from './typeguard';
export class TimeSigNote extends Note {
    constructor(timeSpec, customPadding) {
        super({ duration: 'b' });
        const timeSignature = new TimeSignature(timeSpec, customPadding);
        this.timeSigInfo = timeSignature.getInfo();
        this.setWidth(this.timeSigInfo.glyph.getMetrics().width);
        // Note properties
        this.ignore_ticks = true;
    }
    static get CATEGORY() {
        return Category.TimeSigNote;
    }
    /* Overridden to ignore */
    // eslint-disable-next-line
    addToModifierContext(mc) {
        // DO NOTHING.
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    draw() {
        const stave = this.checkStave();
        const ctx = this.checkContext();
        this.setRendered();
        if (!this.timeSigInfo.glyph.getContext()) {
            this.timeSigInfo.glyph.setContext(ctx);
        }
        this.timeSigInfo.glyph.setStave(stave);
        this.timeSigInfo.glyph.setYShift(stave.getYForLine(2) - stave.getYForGlyphs());
        this.timeSigInfo.glyph.renderToStave(this.getAbsoluteX());
    }
}
